import { InvoiceData } from '../_models/invoicedata';
import { InvoicelistService } from '../_services/invoicelist.service';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';

export class InvoiceDataSource implements DataSource<InvoiceData> {

    private invoiceSubject = new BehaviorSubject<InvoiceData[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this.loadingSubject.asObservable();

    constructor(private invoicelistservice: InvoicelistService) { }

    connect(collectionViewer: CollectionViewer): Observable<InvoiceData[]> {
        return this.invoiceSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.invoiceSubject.complete();
        this.loadingSubject.complete();
    }

    loadInvoice(filter = '',
        sortDirection = 'asc', pageIndex = 0, pageSize = 10) {

        this.loadingSubject.next(true);

        this.invoicelistservice.findInvoices(filter, sortDirection,
            pageIndex, pageSize).pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe(invoice => this.invoiceSubject.next(invoice));
    }

    getrlable(page: number, pageSize: number, length: number) {
        if (length === 0 || pageSize === 0) { return `0`; }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex}`;
    }
}
